import {memo, useState} from "react";
import {useTranslation} from "react-i18next";
import Modal from "../../Modal";

function GoodsDetailCommentBlock({ total, list }) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const item = list.length > 0 ? list[0] : null;
  
  const modalHandle = () => {
    if (list.length > 0){
      setVisible(!visible);
    }
  };
  
  return (
    <>
      <div className="p-[12px]">
        <div className="justify-between flex">
          <p className="text-[14px] font-bold">{t('宝贝评价')} ({total})</p>
          {
            list.length > 0 &&
            <p onClick={modalHandle}
               className="text-[14px] text-[#999]">{t('查看全部')}</p>
          }
        </div>
        {
          list.length > 0 && item ?
            <div onClick={modalHandle}>
              <div className="mt-[10px] relative">
                <div className="inline-block rounded-full w-[35px] h-[35px] bg-[#aaa]">
                  {
                    item.headImg && <img src={item.headImg} className="w-[100%] h-[100%]"/>
                  }
                </div>
                <div className="inline-block ml-[10px]" style={{ verticalAlign: 'top' }}>
                  <p className="text-[12px]">{item.nickname || '匿名用户'}</p>
                  <p className="text-[#666] text-[12px]">{item.updateTime}</p>
                </div>
                
                <p className="absolute right-0 top-0">
                  {
                    Array.from({ length: item.starNum }).map(item => 1)
                      .map((star, index) => (
                        <i className="iconfont icon-star-fill text-[#FFC75A]"
                           key={index}/>
                      ))}
                </p>
              </div>
              <p className="text-[13px] pt-[8px] pl-[8px]">
                {item.comment || '无评价'}
              </p>
            </div> :
            <div className="text-center text-[14px] py-[8px]">{t('暂无评价信息')}</div>
        }
      </div>
      <Modal visible={visible} title="评价" onClose={modalHandle}>
        <div className="p-[10px] pt-[5px] pb-[53px]">
          {
            list.length > 0 &&
            list.map((child, i) => (
              <div key={i} className="border-bottom-1px border-[#eee] py-[12px]">
                <div className="relative">
                  <div className="inline-block rounded-full w-[35px] h-[35px] bg-[#aaa]">
                    {
                      child.headImg && <img src={child.headImg} className="w-[100%] h-[100%]"/>
                    }
                  </div>
                  <div className="inline-block ml-[10px]" style={{ verticalAlign: 'top' }}>
                    <p className="text-[12px]">{child.nickname || '匿名用户'}</p>
                    <p className="text-[#666] text-[12px]">{child.updateTime}</p>
                  </div>
                  
                  <p className="absolute right-0 top-0">
                    {
                      Array.from({ length: child.starNum }).map(item => 1)
                        .map((star, index) => (
                          <i className="iconfont icon-star-fill text-[#FFC75A]"
                             key={index}/>
                        ))}
                  </p>
                </div>
                <p className="text-[13px] pl-[8px]" onClick={modalHandle}>
                  {child.comment || '无评价'}
                </p>
              </div>
            ))
          }
        </div>
      </Modal>
    </>
  );
}

export default memo(GoodsDetailCommentBlock);
